module.exports = __webpack_public_path__ + "static/media/gc-bus-happy.dbe9d5ed.png";